<div>
    <mat-icon [svgIcon]="icon.name"></mat-icon>
    <div class="notification" *ngIf="numberNotification > 0">
    </div>
</div>